import { SelectOption } from "../../../../../components/Form/Form.types";

export const getObjValueByName = (array: SelectOption[], name: string) => {
  return array.find((val) => val.value === name);
};
